import React, { Fragment } from "react";

import { API_URL } from "../../config";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { get } from "lodash";
import { getToken } from "ra-friendsofbabba";
import { useTranslate } from "react-admin";

const options = [
  "resources.technical-report-evals.buttons.print_proposal",
  "resources.technical-report-evals.buttons.print_executive_project",
  "resources.technical-report-evals.buttons.print_technical_report",
  "resources.technical-report-evals.buttons.print_technical_report_eval",
];

const PrintToolbarButton = ({ record, reportType }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleMenuItemClick = (event, option) => {
    let printArgs = option.split(".");
    let print = printArgs[printArgs.length - 1];
    let action;
    switch (print) {
      case "print_proposal":
        action = `/technical-report-evals/print-proposal?id=${get(
          record,
          "id"
        )}`;
        break;
      case "print_executive_project":
        action = `/executive-projects/print?id=${get(
          record,
          "technical_report.executive_project_id"
        )}`;
        break;
      case "print_technical_report":
        action = `/technical-reports/print?id=${get(
          record,
          "technical_report_id"
        )}`;
        break;
      case "print_technical_report_eval":
        action = `/technical-report-evals/print?id=${get(record, "id")}`;
        break;
      default:
        break;
    }
    action = `${API_URL}${action}&token=${getToken()}`;
    window.open(action, "_blank");
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const translate = useTranslate();
  return (
    <Fragment>
      <Button
        ref={anchorRef}
        variant="contained"
        color="primary"
        disableElevation
        aria-haspopup="menu"
        onClick={handleToggle}
      >
        {translate("resources.technical-report-evals.buttons.print")}
        <ArrowDropDownIcon />
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        placement="top-start"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement,
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      onClick={(event) => handleMenuItemClick(event, option)}
                    >
                      {translate(
                        option +
                          (option ===
                            "resources.technical-report-evals.buttons.print_technical_report" &&
                          reportType === 3
                            ? "_final"
                            : "")
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};
export default PrintToolbarButton;
